import styled from '@emotion/styled';
import { media } from '../../services/media';

export const BubblesWrapper = styled.div`
    margin: 0 -15px;

    ${media.min('md')} {
        max-width: 90%;

        margin: 0 auto;
    }

    ${media.min('lg')} {
        max-width: 100%;
        flex: 1;
    }

    .BubbleSVG {
        display: flex;

        &--bubbleMyScore1 {
            width: 320px;
            margin-right: 0;
            margin-left: auto;
            right: -58px;
            max-width: 635px;

            .BubbleSVG__content-wrapper {
                padding-right: 20%;
            }

            ${media.min('md')} {
                right: auto;
                margin: 0 auto;
            }

            ${media.min('lg')} {
                width: 33.1vw;
            }

            ${media.min('xxl')} {
                left: -50px;
                width: 560px;
            }
        }

        &--bubbleMyScore2 {
            width: 286px;
            left: -39px;
            margin-top: -40px;
            max-width: 564px;

            .BubbleSVG__content-wrapper {
                @media (max-width: 767px) {
                    padding-left: 14%;
                }
            }

            ${media.min('md')} {
                left: auto;
                margin-top: -25px;
            }

            ${media.min('lg')} {
                width: 29.4vw;
                margin-top: -6vw;
                left: -10%;
            }

            ${media.min('xxl')} {
                left: -180px;
                width: 500px;
                margin-top: -50px;
            }
        }

        &--bubbleMyScore3 {
            width: 256px;
            margin: -27px 0 0 auto;
            right: -14px;
            max-width: 509px;

            .BubbleSVG__content-wrapper {
                padding-top: 23%;

                ${media.min('xxl')} {
                    padding-left: 12%;
                }
            }

            h3 {
                margin-bottom: 27px;

                ${media.min('xxl')} {
                    margin-bottom: 60px;
                }
            }

            ${media.min('md')} {
                right: 35px;
                margin-top: -260px;
            }

            ${media.min('lg')} {
                width: 26.52vw;
                margin-top: -27vw;
                right: 0;
            }

            ${media.min('xxl')} {
                margin-top: -420px;
                width: 450px;
            }
        }
    }
`;
